import * as React from "react";
import { Props } from "../types";
import { ImageModal } from "./ImageModal";
import { createPortal } from 'react-dom';

export const GalleryImage = (props: Props.GalleryImage) => {

    return <div className={'c-wp-gallery__item__link'}>
        <button className={'c-wp-gallery__link__btu'} onClick={event => props.onClick(event,props.imageIndex)}>
            <figure className="c-wp-gallery__item__figure" style={{backgroundImage:`url(${props.galleryImages[props.imageIndex].imageUrl})`,backgroundPositionX: props.galleryImages[props.imageIndex].position.x,backgroundPositionY: props.galleryImages[props.imageIndex].position.y}}>
            <img src={props.galleryImages[props.imageIndex].imageUrl} alt={props.galleryImages[props.imageIndex].imageAlt} className={'h-sr-only'}/></figure>
        </button>
    </div>
}
